import {Component, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {CommonModule} from '@angular/common';
import {HttpService} from "../service/http.service";
import {GalleryComponent, GalleryItem, GalleryItemEvent} from "@daelmaak/ngx-gallery";
import {MatDialog} from "@angular/material/dialog";
import {DialogImagePopupComponent} from "./modal/dialog-image-popup/dialog-image-popup.component";
import {BehaviorSubject} from "rxjs";


@Component({
  selector: 'app-card-details',
  templateUrl: './card-details.component.html',
  styleUrls: ['./card-details.component.css'],
  standalone: true,
  imports: [CommonModule, GalleryComponent]
})
export class CardDetailsComponent implements OnInit {

  constructor(public httpService: HttpService,
              private dialog: MatDialog,
              private route: ActivatedRoute) {
  }

  public isLoading: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);

  ddptInfo: any
  ddpkId: any
  companyOid: any

  base64String = 'data:image/jpeg;base64,';
  images: GalleryItem[] = []

  ngOnInit(): void {
    this.isLoading.next(true);
    this.route.paramMap.subscribe(params => {
      const ddpkId = params.get('id');
      console.log('ddpkId:', ddpkId);
      this.ddpkId = ddpkId;

      this.route.queryParams.subscribe(params => {
        const companyOid = params['company-oid'];
        console.log('company-oid:', companyOid);
        this.companyOid = companyOid;

        this.getGGPTInfo()
        this.getImages()

      });
    });
  }

  getGGPTInfo() {
    this.httpService.getDDPTInfo(this.ddpkId, this.companyOid)
      .subscribe({
        next: (res) => {
          if (res) this.ddptInfo = res
        }, error: (err) => {
          console.error('getDDPTInfoError: ', err);
        }, complete: () => {
        }
      })
  }

  getImages() {
    this.httpService.getImages(this.ddpkId, this.companyOid)
      .subscribe({
        next: (res) => {
          console.log('images: ', res)
          if (res.length) {
            this.images = [];
            res.map((img: any) => {
              this.images.push({src: this.base64String + img})
            });
          }
        }, error: (err) => {
          this.isLoading.next(false);
          this.images = []
          console.error('getImagesError: ', err.statusText);
        }, complete: () => {
          this.isLoading.next(false);
        }
      })
  }

  onImageClick(item: GalleryItemEvent) {
    const isMobile = window.innerWidth <= 768;
    
    this.dialog.open(DialogImagePopupComponent, {
      width: isMobile ? '95vw' : '90vw',
      maxWidth: isMobile ? '100vw' : '1400px',
      height: 'auto',
      maxHeight: isMobile ? '95vh' : '90vh',
      closeOnNavigation: true,
      hasBackdrop: true,
      panelClass: 'responsive-dialog',
      data: {images: this.images, selectedIndex: item.index},
    });
  }

}
